import { render } from "./eventpopup.vue?vue&type=template&id=81bf8b8e"
import script from "./eventpopup.vue?vue&type=script&lang=js"
export * from "./eventpopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__